function sandboxBase() {
  const explicit = process.env.VUE_APP_MATCHMAKING_V2_SANDBOX_BASE
  if (explicit) {
    return String(explicit).replace(/\/$/, '')
  }
  const v1 = process.env.VUE_APP_BASE_URL || ''
  if (v1) {
    return String(v1).replace(/\/api\/v1\/?$/i, '/api/v2-sandbox').replace(/\/$/, '')
  }
  return 'http://127.0.0.1:8000/api/v2-sandbox'
}

const BASE = sandboxBase()

function abs(path) {
  return BASE + path
}

export default [
  {
    name: 'status',
    path: abs('/status'),
    method: 'get',
    loading: false,
    alert: false,
    commits: [],
    defaultHeader: {},
    defaultBody: {},
  },
  {
    name: 'seed',
    path: abs('/seed'),
    method: 'post',
    loading: false,
    alert: false,
    commits: [],
    defaultHeader: {},
    defaultBody: {},
  },
  {
    name: 'crisis',
    path: abs('/markets/:marketId/crisis-resources'),
    method: 'get',
    loading: false,
    alert: false,
    commits: [],
    defaultHeader: {},
    defaultBody: {},
  },
  {
    name: 'fromDraft',
    path: abs('/client-requirement-snapshots/from-draft'),
    method: 'post',
    loading: false,
    alert: false,
    commits: [],
    defaultHeader: {},
    defaultBody: {},
  },
  {
    name: 'getSnapshot',
    path: abs('/client-requirement-snapshots/:id'),
    method: 'get',
    loading: false,
    alert: false,
    commits: [],
    defaultHeader: {},
    defaultBody: {},
  },
  {
    name: 'createMatchRun',
    path: abs('/match-runs'),
    method: 'post',
    loading: false,
    alert: false,
    commits: [],
    defaultHeader: {},
    defaultBody: {},
  },
  {
    name: 'eligible',
    path: abs('/matchmaking/eligible'),
    method: 'post',
    loading: false,
    alert: false,
    commits: [],
    defaultHeader: {},
    defaultBody: {},
  },
  {
    name: 'getRecommendation',
    path: abs('/recommendations/:recommendationId'),
    method: 'get',
    loading: false,
    alert: false,
    commits: [],
    defaultHeader: {},
    defaultBody: {},
  },
  {
    name: 'select',
    path: abs('/match-runs/:runId/select'),
    method: 'post',
    loading: false,
    alert: false,
    commits: [],
    defaultHeader: {},
    defaultBody: {},
  },
  {
    name: 'memberSlots',
    path: abs('/recommendations/:recommendationId/members/:memberId/slots'),
    method: 'get',
    loading: false,
    alert: false,
    commits: [],
    defaultHeader: {},
    defaultBody: {},
  },
  {
    name: 'validateMatch',
    path: abs('/bookings/validate-match'),
    method: 'post',
    loading: false,
    alert: false,
    commits: [],
    defaultHeader: {},
    defaultBody: {},
  },
  {
    name: 'hold',
    path: abs('/bookings/hold'),
    method: 'post',
    loading: false,
    alert: false,
    commits: [],
    defaultHeader: {},
    defaultBody: {},
  },
  {
    name: 'getHold',
    path: abs('/bookings/holds/:holdId'),
    method: 'get',
    loading: false,
    alert: false,
    commits: [],
    defaultHeader: {},
    defaultBody: {},
  },
  {
    name: 'releaseHold',
    path: abs('/bookings/holds/:holdId/release'),
    method: 'post',
    loading: false,
    alert: false,
    commits: [],
    defaultHeader: {},
    defaultBody: {},
  },
  {
    name: 'checkoutHold',
    path: abs('/bookings/holds/:holdId/checkout'),
    method: 'post',
    loading: false,
    alert: false,
    commits: [],
    defaultHeader: {},
    defaultBody: {},
  },
  {
    name: 'getBooking',
    path: abs('/bookings/:bookingId'),
    method: 'get',
    loading: false,
    alert: false,
    commits: [],
    defaultHeader: {},
    defaultBody: {},
  },
]
